import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/startOfDay/index.js';

var require$$40 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$40 as default };
